export default __webpack_public_path__ + "static/media/main-characters-end-lg-2x.80b182b6.jpg";